"use client";
import { motion } from "framer-motion";
import HeroUI from "~/components/ui/hero";
import CardUI from "~/components/ui/card";
import { testimonials, type Testimonial } from "content/testimonials";

export default function TestimonialsSection() {
  const duplicatedData = [...testimonials, ...testimonials];

  return (
    <HeroUI>
      <HeroUI.Container>
        <div className="w-full overflow-hidden">
          <motion.div
            className="flex w-max gap-4"
            animate={{ x: "50%" }}
            transition={{
              repeat: Infinity,
              ease: "linear",
              duration: 80,
            }}
          >
            {duplicatedData.map((item: Testimonial, idx) => (
              <CardUI
                key={idx}
                variant="morph"
                className="flex w-80 shrink-0 flex-col gap-4 p-5"
              >
                <div className="flex items-center gap-3">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={item.profileUrl}
                    alt={item.name}
                  />
                  
                  <div>
                    <h5 className="text-lg font-semibold">{item.name}</h5>
                    <h6 className="text-sm font-light">{item.role}</h6>
                  </div>
                </div>
                <p className="text-sm text-gray-100 line-clamp-5" title={item.message}>{item.message}</p>
              </CardUI>
            ))}
          </motion.div>
        </div>
      </HeroUI.Container>
    </HeroUI>
  );
}
